import React from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { TechRoleService } from "../../../services/TechRoleService";

export default function TechRoleDelete({ techRole, onClose, isOpen }) {
  let { t } = useTranslation();
  function deleteTechRole() {
    TechRoleService.delete(techRole.id).then((data) => {
      onClose();
    });
  }

  return (
    <ModalContainer
      modalTitle={t("Delete  Tech Role")}
      onClose={onClose}
      submitButtonAction={deleteTechRole}
      submitButtonTitle={t("Delete")}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={onClose}
      submitButtonType="button"
      isOpen={isOpen}
    >
      <div className="form-group text-center">
        <label className="label"> {techRole?.description}</label>
        <br />
        <label className="label">
          {t("Are you sure you want to delete ?")}
        </label>
      </div>
    </ModalContainer>
  );
}
